import React, { Component } from "react";
import Select from "react-select";
import DropDown from "./popup/DropDown";

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    fontFamily: "FontFirst2, Roboto",
  }),
  control: (base) => ({
    ...base,
    fontFamily: "FontFirst2, Roboto",
    padding: "2px 0",
  }),
};

class SimpleDDL extends Component {

  selectRef = React.createRef();

  isScrollInsideSelectMenu = (event) => {
    return event.target.closest(".rs__menu");
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }

  handleScroll = (event) => {
    if (this.isScrollInsideSelectMenu(event)) return;
    
    if (this.selectRef.current) {
      this.selectRef.current.blur();
    }
  };


  render() {
    const {
      id,
      label,
      placeHolder,
      mandatory,
      errorMessage,
      onClickView,
      readOnly,
      box,
      styles,
      showErrorWithoutMandatory,
      ...rest
    } = this.props;
    return (
      <div
        className={`margin-bottom-20px ${
          this.props.containerclassname ? this.props.containerclassname : ""
        }`}
      >
        {box === "search" ? (
          <>
            <div className="margin-5px">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>
                  {label} {mandatory && <span style={{ color: "red" }}>*</span>}
                </h4>
              </div>
            </div>
            <Select
              id={id}
              ref={this.selectRef}
              menuPosition="fixed"
              menuPortalTarget={document.body} // adjustment for ddl All locator receiving
              classNamePrefix="rs"
              style={{ backgroundColor: readOnly && "#E6E6E6" }}
              // styles={{ ...selectStyles, ...styles }}
               styles={{
                ...selectStyles,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // adjustment for ddl All locator receiving
                ...styles,
              }}
              isDisabled={readOnly && true}
              components={{
                Option: (props) => <CustomOption {...props} id={id} />,
              }}
              {...rest}
            />
          </>
        ) : box === "multiselect" ? (
          <>
            <div className="margin-5px">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>
                  {label} {mandatory && <span style={{ color: "red" }}>*</span>}
                </h4>
              </div>
            </div>
            <Select
              id={id}
              style={{ backgroundColor: readOnly && "#E6E6E6" }}
              isMulti={true}
              styles={{
                ...selectStyles,
                multiValue: (styles) => ({
                  ...styles,
                  backgroundColor: "#0096fb",
                }),
                multiValueRemove: (styles) => ({
                  ...styles,
                  color: "white",
                }),
                ...styles,
              }}
              components={{
                Option: (props) => <CustomOption {...props} id={id} />,
              }}
              isDisabled={readOnly && true}
              {...rest}
            />
          </>
        ) : (
          <>
            <div className="margin-5px display-flex-normal">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>
                  {label} {mandatory && <span style={{ color: "red" }}>*</span>}
                  {onClickView && (
                    <span
                      className="margin-left-5px margin-right-5px"
                      style={{ fontWeight: "bold" }}
                    >
                      |
                    </span>
                  )}
                  {onClickView && (
                    <span
                      onClick={() => onClickView()}
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      View
                    </span>
                  )}
                </h4>
              </div>
            </div>
            <DropDown
              {...rest}
              type="bizpar"
              title={` -- Please Select ${label ? label : placeHolder ? placeHolder : ""} --`}
            />
          </>
        )}
        {mandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">{errorMessage}</p>
        )}
        {errorMessage && showErrorWithoutMandatory && (
          <p className="txt-site txt-11 color-red margin-top-5px">{errorMessage}</p>
        )}
      </div>
    );
  }
}

export default SimpleDDL;

const CustomOption = ({ innerProps, isDisabled, ...rest }) => (
  <>
    {!isDisabled ? (
      <option
        {...innerProps}
        id={rest.id + "_" + rest.label}
        className={rest.isSelected ? "css-option css-option-focus" : "css-option"}
      >
        {rest.label}
      </option>
    ) : null}
  </>
);